<template>
  <div class="stat-icon toggle" :class="{ active: !!active, condensed: condensed }" @click.prevent="toggle">
    <div class="icon-wrapper">
      <Icon :name="icon" class="size-2x" />
    </div>
    <div class="name">{{ name }}</div>
  </div>
</template>

<script setup lang="ts">
const props = defineProps<{
  name: string
  reset?: string
  icon?: string
  resetValue?: number
  iconOff?: string
  condensed?: boolean
}>()

const model = defineModel<boolean>()
const active = useResource(ref(props.name))

watch(active, (act) => {
  model.value = !!act
})

const icon = computed(() =>
  active.value ? props.icon || 'fa6-solid:square-check' : props.iconOff || 'fa6-regular:square'
)

const toggle = () => {
  active.value = active.value === 1 ? 0 : 1
}

onRest(props.reset ?? 'lr', () => {
  active.value = props.resetValue ?? 0
})
</script>

<style scoped lang="postcss">
.stat-icon.toggle {
  cursor: pointer;
  justify-content: center;

  &.condensed {
    font-size: 0.8em;
  }

  &.active .icon {
    color: var(--text-highlight);
  }

  &:hover {
    background-color: var(--bg-primary);
  }
}
</style>
